import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LPLogoWName } from "../../assets/index";
import { useResetPasswordLinkMutation } from "./apiSlice";
import { displayToast } from '../../utils/toast';
import { ROUTES } from "@Constants/routes";
import "./styles"
import styles from "./styles";

const ResetLink = () => {


  const [email, setEmail] = useState<string>('')

  const navigate = useNavigate();

  const [getResetPasswordLink, { data: getResetPasswordLinkData, error: getResetPasswordLinkErr, isLoading: getResetPasswordLinkLoading }] = useResetPasswordLinkMutation();

  // const userLogin

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e?.target?.name == 'email') setEmail(e.target.value);
  };

  const onSubmitClick = (e:any)=>{
    e.preventDefault()
    if (email?.length > 0)
      getResetPasswordLink({ email});
  }

  useEffect(() => {
    document.title = "LinkPlease - Forget Password";
  }, []);

  useEffect(() => {

    if (getResetPasswordLinkData){
      setEmail('')
      displayToast('success', getResetPasswordLinkData?.message || "Password reset link sent sent on email")
    }
    
  },[getResetPasswordLinkData, getResetPasswordLinkErr]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed" 
      style={styles.LOGIN_CONTAINER}>
      <div className="w-[90%] max-w-[400px] flex flex-col items-center bg-white p-8 rounded-2xl">
        <div className="mb-8">
          <img src={LPLogoWName} className="w-[250px]" alt="Linkplease Logo" />
        </div>
        
        <div className="text-center mb-4">
          <h1 className="text-[1.2rem] font-semibold">Forget Password</h1>
        </div>
        
        <form onSubmit={onSubmitClick} className="w-full space-y-4 my-6">
          <div>
            <input
              type="email"
              name="email"
              autoComplete="false"
              onChange={handleChange}
              id="email"
              value={email}
              placeholder="Registered Email Id"
              className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={getResetPasswordLinkLoading}
            className="w-full bg-[#3535d5] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
          >
            {getResetPasswordLinkLoading ? "Sending Reset Link..." : "Send Reset Link"}
          </button>
        </form>


        <div className="mt-6 text-center">
          <p className="text-[#787781] text-sm">
            <span 
              className="text-[#6561FF] hover:cursor-pointer hover:underline"
              onClick={() => navigate(ROUTES.LOGIN)}
            >
              {"<"} back to login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetLink;
